export * from './adapter-user-context-properties.interface';